export const SET_ALL_CLIENT_CONFIG_LIST = 'SET_ALL_CLIENT_CONFIG_LIST';
export const RESET_CLIENT_CONFIG_DATA = 'RESET_CLIENT_CONFIG_DATA';
